import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfCurbsideOversized extends AbstractProductType {

  name = 'self_curbside_oversized'
  title = 'Self Curbside Oversized'

  curbside = true
  oversized = true
  format = ProductTypeFormat.Uncovered

}
